import { render, staticRenderFns } from "./App.vue?vue&type=template&id=c470c21a"
import script from "./script/app.js?vue&type=script&lang=js&external"
export * from "./script/app.js?vue&type=script&lang=js&external"
import style0 from "./less/app.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports